<template>
  <f7-list
    class="player-playlist"
    :class="{ dark }"
    ref="list">
    <f7-list-item
      v-for="(t, i) in playlist"
      :key="i + '-' + t.subtitle"
      :ref="'item' + i"
      :title="t.subtitle"
      :class="{ active: i === track }"
      @click="$emit('play', i)">
      <div
        slot="media"
        class="playlist-index">
        {{ i + 1 }}
      </div>
      <FlatIcon
        v-if="i === track && playing"
        slot="after"
        :size="26"
        name="speaker" />
    </f7-list-item>
  </f7-list>
</template>

<script>
export default {
  name: 'PlayerPlaylist',
  props: {
    playlist: {
      type: Array,
      required: true
    },
    playing: {
      type: Boolean
    },
    track: {
      type: Number,
      default: -1
    }
  },
  methods: {
    scrollTo (n) {
      const items = this.$refs['item' + n]
      if (items && items[0]) {
        const item = items[0].$el
        const top = item.offsetTop
        this.$refs.list.$el.scrollTo({ top, behavior: 'smooth' })
      }
    }
  }
}
</script>

<style lang="scss">
.player-playlist {
  --f7-list-margin-vertical: 0px;
  max-height: 100%;
  overflow: auto;
  cursor: pointer;
  ul {
    display: block;
  }
  .item-title {
    line-height: 28px !important;
  }
  .playlist-index {
    min-width: 18px;
    padding: 0 4px;
    height: 23px;
    border-radius: 3px;
    text-align: center;
    font-size: 12px;
    line-height: 23px;
    background: white;
    box-shadow: rgba(0, 0, 0, 0.2) 0px 2px 4px 0px;
  }
  .active {
    .playlist-index {
      background: var(--f7-theme-color);
      color: white;
      box-shadow: none;
    }
  }
  &.dark {
    .playlist-index {
      background: black;
    }
    .active {
      .playlist-index {
        background: var(--f7-theme-color);
      }
    }
  }
}
</style>
